import { render, staticRenderFns } from "./ExpandBtn.vue?vue&type=template&id=08474cea&scoped=true&"
import script from "./ExpandBtn.vue?vue&type=script&lang=ts&"
export * from "./ExpandBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08474cea",
  null
  
)

export default component.exports